module.exports = __webpack_public_path__ + "static/media/WAVES.26378914.png";